/*** AUDIO ***/

import { AudioOptions } from "../config/interfaces";
const PATHMEDIA = window.location.port != "" ? '../assets/audio' : `/modules/custom/co_150_core/trivia/sources/dist/assets/audio`

export default class Audio {
    id: string;
    target: HTMLAudioElement;
    audioOptions?: AudioOptions;

    constructor(id: string, audioOptions?: AudioOptions) {
        this.id = id;
        this.audioOptions = audioOptions;
        this.init()
    }

    init() {
        this.createAudio();
    }

    createAudio() {
        let { fileName, loop, autoplay, preload, appendToDOM } = this.audioOptions
        let nwAudio = document.createElement("audio");
        let nwSource = document.createElement("source");

        nwAudio.id = this.id;
        nwAudio.loop = loop || false;
        nwAudio.preload = preload || "auto";
        nwSource.src = `${PATHMEDIA}/${fileName}`;
        nwSource.type = "audio/mpeg";
        nwAudio.append(nwSource);

        if (autoplay) this.playAudio();

        if (appendToDOM) {
            let refElement: HTMLElement = document.querySelector(appendToDOM)
            refElement && refElement.insertAdjacentElement('beforeend', nwAudio)
        }

        this.target = nwAudio;
    }

    playAudio() {
        let { state } = this.audioOptions
        state = 'Play'
        this.target.play()
    }

    stopAudio() {
        let { state } = this.audioOptions
        state = 'Stop'
        this.target.pause()
    }
}